import { ListMyOrgFunctionsRequestSchema, ListMyOrgFunctionsResponseSchema } from './list-my-org-functions.schema';
/**
 * List My OrgFunctions Endpoint Contract
 *
 * Retrieves the current user's held OrgFunctions (mainRole + secondary roles +
 * led), each tagged with `via`. Used by the Meine Funktionen personal-scope list.
 */ export const listMyOrgFunctionsContract = {
    method: 'GET',
    path: '/api/v2/org-function/mine',
    description: "Retrieve the current user's held OrgFunctions, each tagged with its link source",
    requestSchema: ListMyOrgFunctionsRequestSchema,
    responseSchema: ListMyOrgFunctionsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=list-my-org-functions.contract.js.map